import { useQuery } from '@tanstack/react-query';
import { getPendingTradeCount } from '../api/trades';
import { useAuthStore } from '../store/authStore';

interface UsePendingTradeCountOptions {
  enablePolling?: boolean;
}

export function usePendingTradeCount(options: UsePendingTradeCountOptions = {}) {
  const { enablePolling = true } = options;
  const { isAuthenticated } = useAuthStore();

  const query = useQuery({
    queryKey: ['trades', 'pending-count'],
    queryFn: async () => {
      return getPendingTradeCount();
    },
    staleTime: 30000,
    refetchInterval: enablePolling ? 30000 : false,
    refetchOnWindowFocus: true,
    enabled: isAuthenticated,
  });

  return {
    ...query,
    count: query.data?.count ?? 0,
  };
}
